import React, { lazy, useContext } from 'react'
import objectPath from 'object-path'
import { Modal } from 'react-bootstrap'
import { DesignContext } from 'contexts/DesignContext'
import { MuiThemeProvider } from '@material-ui/core'
import { themeDefault } from 'designer/component/display/themes/layoutTheme'

const FavoriteModal = ({ menu, modalCode, isOpen = false, setIsOpen }) => {
  const Component = lazy(() => import(`designer/display/favorite`))
  const designContext = useContext(DesignContext)
  const {
    jsonForm,
    setFormData,
    setTableRefresh,
    setDesignerPropsData,
  } = designContext
  const formData = objectPath.get(jsonForm, 'formData')
  const schemaTag = objectPath.get(jsonForm, 'schema.mapTag')
  const designerPropsData = objectPath.get(jsonForm, 'designerPropsData')
  const designerData = objectPath.get(designerPropsData, 'data')
  const designerProps = objectPath.get(designerPropsData, 'favoriteProps')
  const designerUi = objectPath.get(designerPropsData, 'ui')
  const designerJsonData = objectPath.get(designerPropsData, 'jsonData') || {}
  const designerJsonName = objectPath.get(designerPropsData, 'jsonName') || {}

  const onCloseModal = () => {
    setIsOpen(false)
  }

  const onSelectData = (data) => {
    let tableRefresh = []
    designerProps.forEach(({ prop, systemType, systemKey }) => {
      let value = objectPath.get(data, prop)
      if (systemType === 'custom') {
        objectPath.set(formData, prop, value)
      } else if (systemType === 'input') {
        objectPath.set(formData, systemKey, value)
      } else if (systemType === 'jsonData') {
        let value = objectPath.get(data, 'jsonData')
        objectPath.set(formData, 'jsonData', value)
        objectPath.set(designerData, 'jsonData', value)
        console.log('designerJsonData', designerJsonData)
        Object.keys(designerJsonData).forEach((key) => {
          let name = designerJsonData[key]
          let value = objectPath.get(data, `jsonData.${name}`)
          value = value === undefined ? '' : value
          objectPath.set(formData, key, value)
          objectPath.set(formData, name, value)
          objectPath.set(designerData, key, value)
          objectPath.set(designerData, name, value)
          if (schemaTag[key] === 'table') {
            tableRefresh.push({ key: key, isFavorite: true, data: value })
          }
        })
      }
    })
    console.log('onSelectData designerData', designerData)
    console.log('onSelectData formData', formData)
    objectPath.set(designerPropsData, 'data', designerData)
    setDesignerPropsData(designerPropsData)
    setFormData(formData)
    setTableRefresh(tableRefresh)
    onCloseModal()
  }

  return (
    <>
      <Modal show={isOpen} size={menu.modalSize}>
        <Modal.Header closeButton onHide={onCloseModal}>
          <h5 className="mb-0">{menu?.name}</h5>
        </Modal.Header>
        <Modal.Body className="p-0">
          <MuiThemeProvider theme={themeDefault}>
            <Component
              modalCode={modalCode}
              onCloseModal={onCloseModal}
              onSelectData={onSelectData}
              designerData={designerData}
              designerJsonName={designerJsonName}
              designerProps={designerProps}
              designerUi={designerUi}
            />
          </MuiThemeProvider>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default FavoriteModal
